import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_left",
  "use": "icon-arrow_left-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-arrow_left\"><path d=\"M652.496 140.496a42.666667 42.666667 0 0 1 61.381333 59.264l-1.04 1.077333L401.669333 512l311.168 311.162667a42.666667 42.666667 0 0 1 1.04 59.264l-1.04 1.077333a42.666667 42.666667 0 0 1-59.264 1.04l-1.077333-1.04-341.333333-341.333333a42.666667 42.666667 0 0 1-1.04-59.264l1.04-1.077334 341.333333-341.333333z\" p-id=\"14076\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/arrow_left.svg
// module id = hJvJ
// module chunks = 22